import React from 'react';
import './BackgroundElements.css';

const BackgroundElements = () => {
  return (
    <div className="background-container">
      <div className="shape circle-1"></div>
      <div className="shape circle-2"></div>
      <div className="shape blob-1"></div>
      <div className="shape blob-2"></div>
      <div className="shape blob-3"></div>
    </div>
  );
};

export default BackgroundElements;